import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Message } from '../types';

interface ChatMessageProps {
  message: Message;
  onOpenStage?: (ref: string) => void;
  stageOpenRef?: string | null;
}

const LEAD_MAX = 160;

/** Erster kurzer Absatz wird zum Serif-Lead, Rest zum Body (Kontor-Stil). */
function splitLead(content: string): { lead: string | null; body: string } {
  const trimmed = content.trim();
  const idx = trimmed.indexOf('\n\n');
  const first = (idx === -1 ? trimmed : trimmed.slice(0, idx)).trim();
  const isProse = first.length > 0 && first.length <= LEAD_MAX &&
    !/^[#\-*>|0-9`]/.test(first);
  if (isProse) {
    return { lead: first, body: idx === -1 ? '' : trimmed.slice(idx + 2).trim() };
  }
  return { lead: null, body: trimmed };
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message, onOpenStage, stageOpenRef }) => {
  const isUser = message.role === 'user';

  if (isUser) {
    return (
      <div className="k-msg k-msg--user">
        <div className="k-msg__who">Sie</div>
        <div className="k-msg__text">{message.content}</div>
      </div>
    );
  }

  const { lead, body } = splitLead(message.content);

  return (
    <div className="k-msg k-msg--agent">
      <div className="k-msg__who">
        Kontor{message.agent ? ` · ${message.agent}` : ''}
      </div>
      <div>
        {lead && (
          <div className="k-msg__lead">
            <ReactMarkdown>{lead}</ReactMarkdown>
          </div>
        )}
        {body && (
          <div className="k-msg__body">
            <ReactMarkdown>{body}</ReactMarkdown>
          </div>
        )}
        {message.panelRef && onOpenStage && (
          <button
            className={'k-msg__stageref' + (stageOpenRef === message.panelRef ? ' is-open' : '')}
            onClick={() => onOpenStage(message.panelRef!)}
          >
            <span className="ref">{message.panelTitle ?? 'Auswertung'}</span>
            <span>Auswertung auf der Bühne</span>
            <span className="arr">→</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
